(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["gallery-section-new-temp"] && !window.DesignMode) return;
  try {
    

 
let allGridItems = [...document.getElementsByClassName("grid-item")];
let popupBg = document.getElementById("popup-bg");
let popupImg = document.getElementById("popup-img");

const openPopup = (e) => {
    let clickedImageSrc = e.target.src;
    popupBg.classList.add("active");
    popupImg.src = clickedImageSrc;
};

const closePopup = () => {
    popupBg.classList.remove("active");
};

allGridItems.forEach((el) => el.addEventListener("click", openPopup));

popupImg.addEventListener("click", (e) => e.stopPropagation());
popupBg.addEventListener("click", closePopup);




  } catch(e) { console.error(e); }
})();
      })();
